// CTAButtons: Call-to-action buttons for public home page
import React, { useState } from 'react';
import { Box, Button } from '@mui/material';
import BookingModal from './BookingModal';

function CTAButtons() {
  const [open, setOpen] = useState(false);
  return (
    <>
      <Box sx={{ display: 'flex', gap: 2, justifyContent: 'center', my: 4, px: { xs: 2, md: 0 } }}>
        <Button variant="contained" color="primary" size="large" onClick={() => setOpen(true)} sx={{ fontWeight: 800, width: { xs: '100%', sm: 'auto' }, py: { xs: 1.1, sm: 0.8 } }}>Book Now</Button>
        <Button variant="outlined" color="primary" size="large" sx={{ fontWeight: 800, width: { xs: '100%', sm: 'auto' }, py: { xs: 1.1, sm: 0.8 } }}>Contact Us</Button>
      </Box>
      <BookingModal open={open} onClose={() => setOpen(false)} />
    </>
  );
}

export default CTAButtons;
